import { Component, OnInit, AfterViewInit, OnDestroy, ChangeDetectorRef, Input } from '@angular/core';
import { AuftragEx, AuftragListItem } from 'src/app/api/model/model';
import { AuftragService } from 'src/app/api/auftrag.service';
import { UiHelper } from 'src/app/api/helper/ui-helper';
import { Subscription } from 'rxjs';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { MyApp } from 'src/app/api/helper/app';
import { Auftragsstatus } from 'src/app/api/model/aufteagsstatus';

import { AppConfig } from 'src/app/api/helper/app.config';
import { RemoteService } from 'src/app/api/remote.service';
import { Router } from '@angular/router';
import { Utils } from 'src/app/api/helper/utils';

const log = new Logger("AuftragUnterauftraegePage");

@Component({
    selector: 'app-auftrag-unterauftraege',
    templateUrl: './auftrag-unterauftraege.page.html',
    styleUrls: ['./auftrag-unterauftraege.page.scss'],
    standalone: false
})
export class AuftragUnterauftraegePage implements OnInit, AfterViewInit, OnDestroy {

    @Input() auftrag: AuftragEx;
    @Input() unterauftraege: AuftragListItem[];

    subscriptions: Subscription[] = [];

    constructor(
        private router: Router,
        private auftragService: AuftragService,
        private cdr: ChangeDetectorRef,
        private remoteService: RemoteService) { }

    async ngOnInit() {
        if (this.unterauftraege) {
            for (const a of this.unterauftraege) {
                // a.label = this.auftragService.getAuftragLabel(a);
                this.auftragService.updateStatus(a);

            }
        }
    }

    ngAfterViewInit(): void {
    }

    ngOnDestroy(): void {
    }

    async onAuftragZugewiesenChanged(e: Event, auftragListItem: AuftragListItem) {
        log?.debug('onAuftragZugewiesenChanged', e);

        const event = e as CustomEvent;
        const zugewiesen = event.detail.checked;

        if (auftragListItem.oldIstZugewiesen === zugewiesen) {
            // Keine Änderung
            return;
        }

        this.zuweisenAuftrag(auftragListItem, zugewiesen);
    }

    async zuweisenAuftrag(auftragListItem: AuftragListItem, zugewiesen: boolean): Promise<boolean> {
        let success = false;

        MyApp.loadingDelayed(true);

        try {
            const result = await this.remoteService.zuweisenAuftrag({
                Key: auftragListItem.Key,
                Zuweisen: zugewiesen
            });

            if (!result) {
                UiHelper.showFehlerKommunikation();
                return;
            }

            MyApp.loading(false);

            if (result.success) {
                if (zugewiesen) {
                    auftragListItem.Auftragsstatus = Auftragsstatus.Zugewiesen;
                    auftragListItem.Geraet = AppConfig.current.geraeteNummer;
                    auftragListItem.istZugewiesen = zugewiesen;
                    auftragListItem.istAnderemGraetZugewiesen = false;
                } else {
                    auftragListItem.Auftragsstatus = Auftragsstatus.Neu;
                    auftragListItem.Geraet = null;
                    auftragListItem.istZugewiesen = false;
                }

                const auftrag = await this.auftragService.getAuftrag(auftragListItem.Key);

                if (zugewiesen) {
                    auftrag.Geraet = AppConfig.current.geraeteNummer;

                    if (auftrag.Auftragsstatus < 35) {
                        auftrag.Auftragsstatus = 35;
                    }
                } else {
                    // Zuweisung wurde aufgehoben
                    auftrag.Geraet = '';

                    if (auftrag.Auftragsstatus < 90) {
                        auftrag.Auftragsstatus = 10;
                    }
                }

                await this.auftragService.speichereAuftrag(auftrag);

                success = true;
            } else {
                UiHelper.showError(result.message, 'Fehler', false, false);
                auftragListItem.istZugewiesen = false;
            }
        } catch (err) {
            MyApp.loading(false);

            UiHelper.showError(err);
            auftragListItem.istZugewiesen = false;
        }

        setTimeout(() => {
            this.cdr.detectChanges();
        });

        return success;
    }

    istAnderemGeraetZugeordnet(unterauftrag: AuftragListItem) {
        return unterauftrag.Auftragsstatus >= Auftragsstatus.Zugewiesen
            && unterauftrag.Geraet !== AppConfig.current.geraeteNummer;
    }

    async onUnterauftragClicked(unterauftrag: AuftragListItem) {
        log?.debug('onUnterauftragClicked', unterauftrag.Key);

        this.router.navigateByUrl('/auftragsliste/details/' + unterauftrag.Key);
    }

    isToggleAnzeigen(unterauftrag: AuftragListItem) {
        if (unterauftrag.Auftragsstatus >= 50) {
            return false;
        }

        if (unterauftrag.Auftragsstatus <= 10) {
            return true;
        }

        if (unterauftrag.istZugewiesen && unterauftrag.Auftragsstatus < 90) {
            return true;
        }

        if (!unterauftrag.istAnderemGraetZugewiesen && !unterauftrag.Geraet && unterauftrag.Auftragsstatus < 90) {
            return true;
        }

        return false;
    }
}